import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export interface CoachStartersResponse {
  prompts: string[]
}

const DEFAULT_STARTERS = [
  'How can I manage a flare-up?',
  'Tips for better sleep with pain',
  'Gentle movement for pelvic pain',
  'When should I see my doctor?',
]

/**
 * Fetches personalized AI-coach starter prompts tailored to the patient's
 * recent pain, cycle phase, sleep, and symptoms. Fresh account or network
 * error → falls back to a sensible generic list so the coach never renders
 * an empty prompt row.
 */
export function useCoachStarters() {
  const query = useQuery({
    queryKey: ['patient', 'coach-starters'],
    queryFn: () => api.get<CoachStartersResponse>('/api/patient/coach-starters'),
    staleTime: 5 * 60_000,
  })

  const prompts =
    query.data?.prompts && query.data.prompts.length > 0
      ? query.data.prompts
      : DEFAULT_STARTERS

  return { prompts, isLoading: query.isLoading }
}
